module.exports = __webpack_public_path__ + "assets/img/special_active.8bbd45bf.png";